import { useEffect, useState } from "react";
import { getProjectsById, getProjectsByIdPro } from "./redux/projectAction";
import { RootState } from "../common/redux/store";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../common/redux/reduxHooks";
import { StructureForm } from "../projects/StructureForm";
import { ProfessionnelForm } from "../projects/ProfessionnelForm";
import { StructureCalendar } from "../scheduler/StructureCalendar";
import { ProfessionnelCalendar } from "../scheduler/ProfessionnelCalendar";
import {
    fetchConsumption,
    SubscriptionConsumption,
} from "../common/redux/subscriptionActions";

export const ProjectPage = () => {
    const userSelector = useAppSelector((state: RootState) => state.user.data);
    const userProData = useAppSelector(
        (state: RootState) => state.userPro.data
    );
    const projects = useAppSelector((state: RootState) => state.projects.data);
    const [, setAccount] = useState(userSelector);
    const [, setIsDisplayPopUpCreateProject] = useState(false);
    const [subscriptionConsumption, setSubscriptionConsumption] =
        useState<SubscriptionConsumption | null>(null);

    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (userSelector.societe) {
            dispatch(getProjectsById(userSelector.id));
            setAccount(userSelector.societe);
            getSubscriptionConsumption();
        } else {
            dispatch(getProjectsByIdPro(userProData.id));
            setAccount(userProData.name);
        }
    }, [dispatch, userSelector, userProData]);

    useEffect(() => {
        if (userSelector.isCreateProject || userProData.isCreateProject) {
            setIsDisplayPopUpCreateProject(true);
        }
    }, [userSelector.isCreateProject, userProData.isCreateProject]);

    const getSubscriptionConsumption = async () => {
        try {
            const response = await fetchConsumption();
            setSubscriptionConsumption(response);
        } catch (error) {
            console.error("Failed to fetch subscription consumption:", error);
        }
    };

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <Box sx={{ justifySelf: "center", mt: 6 }}>
                    {userSelector.societe ? (
                        <StructureForm />
                    ) : (
                        <ProfessionnelForm />
                    )}
                    <Typography
                        sx={{
                            mt: 4,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {subscriptionConsumption
                            ? t("project.subscription.consumption", {
                                  count: subscriptionConsumption.activeProjectsCount,
                                  max: subscriptionConsumption.projectSlots,
                              })
                            : "-"}
                    </Typography>
                    <Box
                        sx={{
                            width: "100%",
                            height: "auto",
                            mb: 10,
                            mt: 4,
                        }}
                    >
                        {userSelector.societe ? (
                            <StructureCalendar
                                disponibilities={userSelector.disponibilities}
                            />
                        ) : (
                            <ProfessionnelCalendar
                                disponibilities={userProData.disponibilities}
                            />
                        )}
                    </Box>
                </Box>
            </Box>
        </>
    );
};
